import { FixedPaymentWUT } from '@wix/form-fields/wut';

export default FixedPaymentWUT;
